import { render } from "./SignUpForm.vue?vue&type=template&id=520633a8&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=520633a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520633a8"]])

export default __exports__